export default __webpack_public_path__ + "static/media/gallery4.983997f0.jpg";